import {useEffect, useState} from "react";
import {Autocomplete, TextField, CircularProgress, useTheme} from '@mui/material';

const BookingStatusListDropdownComponent = (props) => {
    const {onChange, value, fullWidth, size, customStyles, disabled, isFetchingBookingStatusList, bookingStatusList, getBookingStatusList} = props;

    const theme = useTheme();

    const [bookingStatusListData, setBookingStatusListData] = useState([]);
    const [stateValue, setStateValue] = useState(null);
    const [inputValue, setInputValue] = useState("");

    
    useEffect(() => {
        getBookingStatusList();
    }, [])

    useEffect(() => {
        setStateValue(value || null);
        setInputValue(value || "");

        if (bookingStatusList?.length > 0) {
            const filteredBookingStatusData = bookingStatusList?.filter((status) => status !== value);

            setBookingStatusListData(filteredBookingStatusData);
        }
    }, [bookingStatusList, value])


    const handleChange = (newValue) => {
        setStateValue(newValue);
        setInputValue(newValue || "");
        onChange(newValue);
    }

    
    return (
        <>
            <Autocomplete
                disabled={disabled ? disabled : false}
                disablePortal
                options={bookingStatusListData}
                getOptionLabel={(option) => option || ""}
                isOptionEqualToValue={(option, value) => option === value}
                fullWidth={fullWidth}
                size={size}
                value={stateValue}
                loading={isFetchingBookingStatusList}
                onChange={(event, newValue) => handleChange(newValue)}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                noOptionsText="Status not found."
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Search booking status"
                        slotProps={{
                            input: {
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {isFetchingBookingStatusList ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: "4px", 
                                height: "42px",
                                paddingTop: '6px', 

                                '& input': {
                                    color: theme.typography.main,
                                    fontSize: 16,
                                    fontWeight: 500,

                                    '&::placeholder': {
                                        color: theme.typography.secondary,               
                                        opacity: 0.45,    
                                        fontSize: 15,    
                                        fontWeight: "400 !important",                     
                                    },
                                },

                                '& fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&:hover fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&.Mui-focused fieldset': {
                                    borderColor: "#253e5a9e",
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: theme.typography.secondary,               
                                opacity: 0.45,    
                                fontSize: 15,    
                                fontWeight: "400 !important",
                                marginTop: "-5px",
                            },
                        }}
                    />
                )}
                sx={{...customStyles}}
            />
        </>
    )
}

export default BookingStatusListDropdownComponent